import React, { createContext, useContext, useEffect, useState } from "react";

const AgentSessionContext = createContext(null);

export function AgentSessionProvider({ children }) {
  const [agent, setAgent] = useState(() => {
    const raw = localStorage.getItem("tgs-agent");
    try { return raw ? JSON.parse(raw) : null; } catch { return null; }
  });

  useEffect(() => {
    if (agent) localStorage.setItem("tgs-agent", JSON.stringify(agent));
    else localStorage.removeItem("tgs-agent");
  }, [agent]);

  return (
    <AgentSessionContext.Provider value={{ agent, setAgent, logout: () => setAgent(null) }}>
      {children}
    </AgentSessionContext.Provider>
  );
}

export const useAgentSession = () => useContext(AgentSessionContext);
